<template>
  <div class="page-job">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/ss`"
          >社会服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="`${$subsitePrefix}/ss/job/list`"
          >岗位实践</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ data.Name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content job-content">
        <div class="head">
          <div class="left">
            <h3>{{ data.Name }}</h3>
            <div class="attrs">
              <p class="registerTimeSpan">
                <span
                  >报名时间：{{
                    formartDate(data.RegistStartTime, "minutes")
                  }}
                  至 {{ formartDate(data.RegistEndTime, "minutes") }}</span
                >
              </p>
              <p class="desc">
                <strong>{{ data.Salary || "面议" }}</strong>
                <span class="job_title">{{ data.Address || "--" }}</span>
                <span class="job_title">
                  岗位实践时间:{{ formartDate(data.StartTime, "minutes") }} 至
                  {{ formartDate(data.EndTime, "minutes") }}</span
                >
                <span class="job_title">招{{ data.RecruitersQty }}人</span>
              </p>
            </div>
          </div>
          <div class="right">
            <div class="btn">
              <a @click="dialogVisible = true" v-if="applyEnable">在线申请</a>
              <a
                v-else
                pointer-events="none"
                disabled="disabled"
                style="border:'black';color:'black';"
              >
                {{ applyBtnTitle }}
              </a>
            </div>
            <el-dialog
              title="申请"
              :visible.sync="dialogVisible"
              width="30%"
              :before-close="handleClose"
            >
              <el-form
                ref="form"
                :model="form"
                :rules="rules"
                label-width="80px"
              >
                <el-form-item label="姓名" prop="Name">
                  <el-input v-model="form.Name"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="Phone">
                  <el-input v-model="form.Phone"></el-input>
                </el-form-item>
                <el-form-item label="申请内容" prop="Content">
                  <el-input v-model="form.Content" type="textarea"></el-input>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm('form')"
                  >确 定</el-button
                >
                <el-button @click="dialogVisible = false">取 消</el-button>
              </span>
            </el-dialog>
          </div>
        </div>
        <div class="body">
          <div class="left" style="padding:20px">
            <div v-html="data.Content"></div>
            <div v-if="data.File.Length > 0" class="attach">
              <div class="attach-title">附件信息</div>
              <p v-for="(item, i) in data.File" :key="i">
                <i class="el-icon-link"></i>
                <a
                  class="file"
                  :href="`/files/${item.ViewFilePath}`"
                  :download="item.FileName"
                  >{{ item.FileName }}</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail } from "api/app";
import { signUpJob, jobAddViewCount } from "api/research";
import ColumnHeader from "_c/ColumnHeader2";
import toolMixin from "@/mixins/content-tools.js";
export default {
  components: {
    [ColumnHeader.name]: ColumnHeader
  },
  mixins: [toolMixin],
  data() {
    return {
      dialogVisible: false,
      data: {},
      enterprise: {},
      tags: [],
      form: {
        JobId: "",
        Content: "",
        Name: "",
        Phone: ""
      },
      rules: {
        Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        Phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        Content: [{required: false}]
      },
      applyEnable: false,
      applyBtnTitle: "在线申请"
    };
  },
  created() {
    this.init();
  },
  methods: {
    loadData() {
      getDetail({ name: "PracticeJob", id: this.$route.params.id }).then(
        res => {
          this.data = res || {};
          this.applyEnable = true;
          var now = new Date();
          if (new Date(res.RegistStartTime) > now) {
            this.applyEnable = false;
            this.applyBtnTitle = "未到报名时间";
          }
          if (new Date(res.RegistEndTime) < now) {
            this.applyEnable = false;
            this.applyBtnTitle = "报名已结束";
          }
        }
      );
      jobAddViewCount({ id: this.$route.params.id }).then(res => {
        if (res.IsSuccess) {
          console.log("增加浏览量");
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.form.JobId = this.data.Id;
          signUpJob(this.form)
            .then(res => {
              if (res.IsSuccess) {
                this.$message.success("报名成功");
                this.dialogVisible = false;
                this.$refs[formName].resetFields();
              }
            })
            .catch(err => {
              this.$message.warning("报名失败:" + err);
            });
        } else {
          this.$message.warning("存在未输入字段");
          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          console.log(_);
          done();
        })
        .catch(_ => {
          console.log(_);
        });
    },
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.registerTimeSpan {
  span {
    position: relative;
    color: #666;
  }
}
.page-job {
  background: #f6f6f9;
  padding-bottom: 40px;
  .job-content {
    padding: 0 0 40px 0;
    .head,
    .body {
      display: flex;
      justify-content: space-between;
    }
    .head {
      padding: 40px 72px;
      border-bottom: 1px solid #eee;
      .left {
        .job_title {
          position: relative;
          padding-left: 10px;
          margin-left: 10px;
          color: #666;
          &::before {
            width: 1px;
            height: 12px;
            background-color: #ccc;
            position: absolute;
            left: 0;
            top: 1px;
            content: " ";
          }
        }
        strong {
          color: #ff6010;
          font-weight: 500;
          font-size: 20px;
        }
        h3 {
          font-size: 24px;
          font-weight: 500;
          padding-bottom: 12px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .date {
          color: #ccc;
          text-align: center;
          padding-top: 10px;
        }
      }
      .btn {
        a {
          width: 88px;
          height: 32px;
          border-radius: 20px;
          border: 1px solid $primary-color;
          color: $primary-color;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          margin-left: 8px;
          &.send {
            color: #fff;
            background-color: $primary-color;
          }
        }
      }
    }
    .body {
      margin: 0 72px;
      .right {
        width: 212px;
        padding-top: 40px;
        .img {
          width: 212px;
          height: 66px;
          border: 1px solid rgba(238, 238, 238, 1);
          justify-content: center;
          align-items: center;
          display: flex;
        }
        h3 {
          font-weight: 500;
          padding: 20px 0 15px 0;
          font-size: 15px;
        }
        p {
          color: #999;
          line-height: 16px;
          height: 16px;
          padding-bottom: 16px;
          display: flex;
          align-items: center;
          i {
            display: inline-block;
            width: 16px;
            height: 16px;
            background: url(~assets/img/feature/intro/ico-industry.png)
              no-repeat left center;
            margin-right: 5px;
          }
          .ico-size {
            background-image: url(~assets/img/feature/intro/ico-size.png);
          }
          .ico-type {
            background-image: url(~assets/img/feature/intro/ico-type.png);
          }
        }
      }
      .left {
        flex: 1;
      }
    }
    .tags {
      color: #999;
      font-size: 12px;
      span {
        background: rgba(252, 252, 252, 1);
        border-radius: 4px;
        border: 1px solid rgba(221, 221, 221, 1);
        padding: 2px 4px;
        margin-right: 8px;
      }
    }
    .content {
      font-size: 14px;
      line-height: 28px;
      color: #666;
      padding-bottom: 20px;
    }
    ::v-deep .comp-column-header {
      padding-top: 24px;
    }
  }
  .attach {
    &-title {
      font-size: 16px;
      margin: 30px 0 10px 0;
    }
    p {
      height: 22px;
      font-size: 16px;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
      padding-bottom: 5px;
      i {
        margin-right: 5px;
      }
      a.file {
        margin-right: 30px;
        text-decoration: underline !important;
      }
      a.btn {
        color: $primary-color;
      }
    }
  }
}
</style>
